export default "__VITE_ASSET__CP9l0Zm1__"